import React, {useState, useEffect} from 'react'
import * as RouterActions from '../../actions/RouterActions'
import * as StoriesActions from '../../actions/StoriesActions'
import {Table, Label, List, Popup, Icon, Loader, Button} from 'semantic-ui-react'
import {useFirebase, useFirestore, useFirestoreConnect} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import Dropzone from 'react-dropzone';
import * as moment from 'moment'
import {env} from '../../constants/Environment';
import { nanoid } from 'nanoid'
import {StoriesNavigation} from './Navigation';

const _ = require('lodash');

export const Browser = (props) => {
    moment.locale('de');
    
    const firebase = useFirebase()
    const dispatch = useDispatch()
    //const [path, setPath] = useState(props.match.params[0].split('/'));
    const firestore = useFirestore();
   // const [isLoading, setIsLoading] = useState(false);

    /*useFirestoreConnect([
        { collection: 'environments/' + env + '/stories' }
    ])

    const stories = useSelector(({ firestore: { data } }) => data['environments/' + env + '/stories']);*/

    const stories = useSelector(({stories}) => (stories.ids === null)?null:stories.ids.map((id) => stories.stories[id]));
    const next = useSelector(({stories}) => stories.next);
    const isLoading = useSelector(({stories}) => (stories.loading || stories.ids === null));

    useEffect(() => {
        dispatch(StoriesActions.fetch_stories());
    }, [false]);

    //const isLoading = typeof stories === 'undefined' || stories === null;
    console.log('Stories', stories);


    const newId = nanoid();

    return (
        <StoriesNavigation breadcrumb={[
            {
                'caption': 'Beiträge',
                'href': '/stories/'
            }
        ]} active="files">
            <div style={{
                padding: '0.5em',
                paddingTop: '1em'
            }}>

                <Button primary labelPosition="left" icon="plus" content="Einen neuen Beitrag verfassen" onClick={(e) => dispatch(RouterActions.push('/stories/' + newId + '/' + nanoid()))}></Button>
                {
                (stories === null)?
                    <Loader active inline />
                :

                    <List divided selection verticalAlign='middle'>
                        {
                            stories.map((story, idx) => {
                                if(typeof story.deleted !== 'undefined' && story.deleted == true)return null;

                                return (typeof story.draft !== 'undefined')?
                                            <List.Item>
                                                <List.Content floated="right">
                                                    {
                                                        (typeof story.published !== 'undefined')?
                                                            <Label color="teal">Veröffentlicht</Label>
                                                        :null
                                                    }
                                                    {
                                                        (typeof story.published === 'undefined' || story.published.version !== story.draft.version)?
                                                            <Label>Entwurf</Label>
                                                        :null
                                                    }
                                                </List.Content>
                                                <List.Content>
                                                <a style={{cursor: 'pointer'}} onClick={(e) => {
                                                    dispatch(RouterActions.push('/stories/' + story.id + '/' + story.draft.version))                                            
                                                }}>
                                                    {
                                                        story.draft.title?
                                                            story.draft.title
                                                        :
                                                            <span style={{
                                                                'font-style': 'italic'
                                                            }}>- Ohne Titel -</span>
                                                    }                                                    
                                                </a>
                                                <small style={{
                                                    display: 'block'
                                                }}>{
                                                    (typeof story.published !== 'undefined')?
                                                        <div>Veröffentlicht {moment(story.draft.modified.toDate()).fromNow()}</div>
                                                    :null
                                                }{(typeof story.published === 'undefined' || story.published.version !== story.draft.version)?
                                                    <div>Letzte Änderung {moment(story.draft.modified.toDate()).fromNow()}</div>
                                                    :null
                                                }
                                                </small>
                                                </List.Content>
                                            </List.Item>
                                        :null
                            })
                        }
                    </List>
                    }
                    {
                        isLoading?
                            <Loader active inline />
                        :
                        <div>
                            {
                                (next !== null)?
                                    <a style={{
                                       cursor: 'pointer' 
                                    }} onClick={(e) => {
                                        dispatch(StoriesActions.fetch_stories(next));
                                    }}>Ältere Einträge laden ›</a>
                                :null
                            }
                        </div>
                    }
                </div>
        </StoriesNavigation>
    )
}